import React, { useState, useEffect } from 'react';
import { Card } from "../components/ui/card"
import { Tabs, TabsContent, TabsList, TabsTrigger } from "../components/ui/tabs"
import { AssignmentService } from '../services/AssignmentService';
import { Assignment } from '../types';
import AssignmentsList from './Assignments/AssignmentsList';
import AssignmentForm from './Assignments/AssignmentForm';
import AssignmentDownloads from './Assignments/AssignmentDownloads';

const Assignments: React.FC = () => {
  const [assignments, setAssignments] = useState<Assignment[]>([]);
  const [editingAssignment, setEditingAssignment] = useState<Assignment | null>(null);

  useEffect(() => {
    fetchAssignments();
  }, []);

  const fetchAssignments = async () => {
    try {
      const data = await AssignmentService.getAssignments();
      setAssignments(data);
    } catch (error) {
      console.error('Error fetching assignments:', error);
      // TODO: Show error message to user
    }
  };

  const handleSubmitAssignment = async (assignment: Assignment | Omit<Assignment, 'id'>) => {
    try {
      if ('id' in assignment) {
        // Update existing assignment
        const updatedAssignment = await AssignmentService.updateAssignment(assignment.id, assignment);
        setAssignments(prev => prev.map(a => a.id === updatedAssignment.id ? updatedAssignment : a));
      } else {
        // Create new assignment
        const createdAssignment = await AssignmentService.createAssignment(assignment);
        setAssignments(prev => [...prev, createdAssignment]);
      }
      setEditingAssignment(null);
    } catch (error) {
      console.error('Error submitting assignment:', error);
      // TODO: Show error message to user
    }
  };

  const handleDeleteAssignment = async (id: string) => {
    try {
      await AssignmentService.deleteAssignment(id);
      setAssignments(prev => prev.filter(assignment => assignment.id !== id));
    } catch (error) {
      console.error('Error deleting assignment:', error);
      // TODO: Show error message to user
    }
  };

  const handleModifyAssignment = (assignment: Assignment) => {
    setEditingAssignment(assignment);
  };

  const handleNewAssignments = () => {

  }

  return (
    <div className="space-y-6">
      <h1 className="text-3xl font-bold">Assignments</h1>
      <Card>
        <Tabs defaultValue="downloads">
          <TabsList>
            <TabsTrigger value="downloads">Files</TabsTrigger>
            <TabsTrigger value="create">Create/Edit</TabsTrigger>
            <TabsTrigger value="list">List</TabsTrigger>
          </TabsList>
          <TabsContent value="downloads">
            <AssignmentDownloads assignments={assignments}  onAssignmentsUpdate={handleNewAssignments}/>
          </TabsContent>
          <TabsContent value="create">
            <AssignmentForm
              onSubmit={handleSubmitAssignment}
              initialAssignment={editingAssignment}
              onCancel={() => setEditingAssignment(null)}
            />
          </TabsContent>
          <TabsContent value="list">
            <AssignmentsList
              assignments={assignments}
              onDelete={handleDeleteAssignment}
              onModify={handleModifyAssignment}
            />
          </TabsContent>
        </Tabs>
      </Card>
    </div>
  );
};

export default Assignments;